import { render } from "./EnduserChatTalkDetailView.vue?vue&type=template&id=1bff2a20&scoped=true"
import script from "./EnduserChatTalkDetailView.vue?vue&type=script&lang=js"
export * from "./EnduserChatTalkDetailView.vue?vue&type=script&lang=js"

import "./EnduserChatTalkDetailView.vue?vue&type=style&index=0&id=1bff2a20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bff2a20"]])

export default __exports__